import React from "react";
import "./Smart_Finance_Solutions_card.css";
import { Link } from "react-router-dom";

function Smart_Finance_Solutions_card(props) {
  return (
    <>
      <Link to={`/term-lifeinsurance?name=${props?.loan}&type=LOAN`}>
        <section className="Smart_Finance_Solutions_card">
          <div className="img_holder">
            <img
              className="finance_img"
              src={process.env.PUBLIC_URL + props?.img}
              alt="finance_img"
            />
          </div>

          <div className="text_holder">
            <p>{props?.loan}</p>
          </div>
        </section>
      </Link>
    </>
  );
}

export default Smart_Finance_Solutions_card;
